<template>
  <v-app>
    <component :is="layout">
      <router-view/>
    </component>
  </v-app>
</template>

<script>
import emptyLayout from '@/layouts/emptyLayout'
import mainLayout from "@/layouts/mainLayout"


export default {
  components: {
    emptyLayout,
    mainLayout
  },
  computed: {
    isAuth() {
      return this.$store.getters.isAuthUser;
    },
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
    
  },
  watch: {
    isAuth(val) {
      if (val === false) {
        this.$router.push('/login')
      }
    },

  },
  created: function () {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        act: 9999,
        ww: 1,
        pp: localStorage.pp,
        pn: localStorage.pn,
      })
    };
    fetch(this.$store.getters.apiUrl, requestOptions)
      .then(async response => {
        const data = await response.json();
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        if (data.isauth == true) {
          this.$store.dispatch('INIT', {isauth:data.isauth})
          this.$store.dispatch('PIPCH', {pip:data.pip})
        }
        if (data.isauth == false) {
          this.$router.push('/login').catch(()=>{})
        }
      })
      .catch(error => {
        console.error('Error!', error)
        this.$router.push('/login')
      });
  }

    
};
</script>
